// extracted by mini-css-extract-plugin
export default {"root":"ConfirmDeleteApplicationModal_root__Pk4yo","sub-header":"ConfirmDeleteApplicationModal_sub-header__QNpTv"};